import { Parser } from "expr-eval-fork";

const parser = new Parser();

export default parser;
